export const WEB_API_URI = process.env.NEXT_PUBLIC_WEB_API_URI
export const PUBLIC_API_URI = process.env.NEXT_PUBLIC_PUBLIC_API_URI
export const AI_API_URI = process.env.NEXT_PUBLIC_AI_API_URI